import en from "./i18n-en-deep-Data"


// en, de, fr, pt
export default {
    en,

}
